import { queryOptions } from "@tanstack/react-query";

import { Coordinates } from "@core/types/common";
import { WeatherApi } from "./weather.api";

export const getWeatherOptions = (
  weatherApi: WeatherApi | null,
  params: {
    coordinates: Coordinates | undefined,
    startDate: string | null,
    endDate: string | null,
  },
  enabled: boolean = true
) =>
  queryOptions({
    queryKey: ["weather", params.coordinates, params.startDate, params.endDate],
    queryFn: () => weatherApi?.getWeatherData(params.coordinates, params.startDate, params.endDate),
    enabled: enabled && !!weatherApi && !!params.coordinates?.lat && !!params.coordinates?.lon && !!params.startDate && !!params.endDate,
  });
